import { render, staticRenderFns } from "./FaxPreview.vue?vue&type=template&id=211c9c5e&"
import script from "./FaxPreview.vue?vue&type=script&lang=js&"
export * from "./FaxPreview.vue?vue&type=script&lang=js&"
import style0 from "./FaxPreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports